<template>
    <v-container fluid class="pa-0">
        <v-row v-if="disabledCheckout && !isAuthor" column justify-center align-center no-gutters>
            <v-container>
            <CheckoutDisabledAlert />
            </v-container>
        </v-row>
        <v-row v-else-if="page" column justify-center align-center no-gutters>
            <v-col cols="12">
                <Content
                    v-if="page && page._id && page.contentSections"
                    :page="page"
                    :template="template"
                />
                <Cart v-if="isCart" />
                <FormCheckout v-if="isCheckout" />
                <FormPayment v-if="isPayment" />
                <OrderConfirmation v-if="isOrderConfirmation" />
                <FormCustomerDetails
                    v-if="isCustomerDetailsForm && !isCustomerCreated"
                />
            </v-col>
        </v-row>
        <v-row v-else>
            <TranslatableStringComponent :tstring="{string: 'noPageFound'}" />
        </v-row>
        <v-dialog v-model="promptToMutateSavedCart" width="500" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-4" primary-title
                    ><TranslatableStringComponent :tstring="{string: 'sharedCartPricingNotice'}" /></v-card-title
                >
                <v-card-text>
                    <p class="mb-0">{{ promptToMutateSavedCartMessage }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="handleLeavePage()">
                        <TranslatableStringComponent :tstring="{string: 'yes'}" />
                    </v-btn>
                    <v-btn
                        color="primary"
                        text
                        @click="handleSavedCartDialog()"
                    >
                        <TranslatableStringComponent :tstring="{string: 'no'}" />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Cart from '~/components/Cart.vue'
import Content from '~/components/Content.vue'
// import Footer from '~/components/Footer.vue'
import FormCheckout from '~/components/forms/FormCheckout.vue'
import FormPayment from '~/components/forms/FormPayment.vue'
import OrderConfirmation from '~/components/OrderConfirmation.vue'
import FormCustomerDetails from '~/components/forms/FormCustomerDetails.vue'
import CheckoutDisabledAlert from '~/components/CheckoutDisabledAlert.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
import handleSnackbar from '~/mixins/handleSnackbar'
export default {
    name: 'TemplateCheckout',
    components: {
        Cart,
        Content,
        // Footer,
        FormCheckout,
        FormPayment,
        OrderConfirmation,
        FormCustomerDetails,
        CheckoutDisabledAlert,
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar],
    props: {
        page: {
            type: Object,
            default: null
        },
        template: {
            type: String,
            default: 'Checkout'
        }
    },
    data() {
        return {
            showHero: false,
            showFooter: true,
            e1: 1,
            disabledCheckout: false,
        }
    },
    computed: {
        ...mapState('savedCarts', [
            'promptToMutateSavedCart',
            'promptToMutateSavedCartMessage',
            'toPage'
        ]),
        ...mapGetters({
            isCustomerCreated: 'auth/isCustomerCreated',
            isAuthor: 'auth/isAuthor',
        }),
        debugData() {
            return {
                template: this.template,
                error: this.error
            }
        },
        isCart() {
            return this.page.slug.en && this.page.slug.en.current === 'cart'
        },
        isCheckout() {
            return this.page.slug.en && this.page.slug.en.current === 'checkout'
        },
        isPayment() {
            return this.page.slug.en && this.page.slug.en.current === 'payment'
        },
        isThankYou() {
            return (
                this.page.slug.en && this.page.slug.en.current === 'thank-you'
            )
        },
        isOrderConfirmation() {
            return (
                this.page.slug.en &&
                this.page.slug.en.current === 'order-details'
            )
        },
        isCustomerDetailsForm() {
            return (
                this.page.slug.en &&
                this.page.slug.en.current === 'customer-details'
            )
        }
    },
    mounted() {
        this.handleRedirect()
    },
    methods: {
        handleRedirect() {
            const isCartEmpty =
                localStorage.getItem('c3cart') &&
                JSON.parse(localStorage.getItem('c3cart')).cartProducts
                    .length === 0
            if (
                isCartEmpty &&
                (this.$route.params.slug ===
                    this.getSlug({ slugName: 'checkout' }) ||
                    this.$route.params.slug ===
                        this.getSlug({ slugName: 'payment' }))
            ) {
                this.routerPush({ type: 'page', slugName: 'cart' })
            }
        },
        handleSavedCartDialog() {
            this.$store.commit('savedCarts/setPromptToMutateSavedCart', false)
        },
        handleLeavePage() {
            this.$store.commit('savedCarts/setPromptToMutateSavedCart', false)
            const message = 'pricingRevertedToYourApprovedPricelist'
            this.hitSnackbar({string: message }, null)
            this.$router.push({
                path: this.toPage,
                query: {
                    isIgnore: true
                }
            })
        }
    }
}
</script>
